iScreenWizard.controller('P2CTestafnameController', function ($scope, $state, $mdDialog, $filter, Ajax, Dictionary, ErrorHandler, userService, Competentieprofiel, Competentiegroep, Competentie, Testafname, p2cService) {

    var pagesize = 20;

    $scope.userService = userService;
    $scope.p2c = p2cService.model;

    $scope.searchTerm = '';

    $scope.testafnames = [];
    $scope.testafnamesPage = 1;
    $scope.testafnamesMorePages = true;
    $scope.alreadyLoading = false;

    $scope.$on('$stateChangeSuccess', function (event, toState) {
        $scope.refresh();
    });

    var refresh = function() {
        p2cService.model.testafnames = [];
        $scope.testafnamesPage = 1;
        $scope.testafnames = [];
        $scope.loadTestafnames();
    };
    $scope.refresh = refresh;

    $scope.loadMoreTestafnames = function() {
        $scope.testafnamesPage = $scope.testafnamesPage+1;
        $scope.loadTestafnames();
    };

    $scope.loadTestafnames = function() {
        if (!$scope.alreadyLoading) {
            $scope.alreadyLoading = true;
            params = {
                pagesize: pagesize,
                page: $scope.testafnamesPage,
                matching_intellectuele_competentie_optie: p2cService.model.intellectuele_competentie_optie
            };
            if (p2cService.model.intellectuele_competentie_optie != 3) {
                params.matching_competentieprofiel_id = p2cService.model.competentieprofiel.id;
            } else {
                params.matching_opleidingsgroep_id = p2cService.model.opleidingsgroep_id;
            }
            if ($scope.searchTerm.length > 0) {
                params.searchterm = $scope.searchTerm;
            }
            Testafname.all(params).then(function (testafnames) {
                $scope.alreadyLoading = false;
                angular.forEach(testafnames, function (testafname) {

                    testafname.index = -1;
                    angular.forEach($scope.p2c.testafnames, function (andereTestafname, index) {
                        if (andereTestafname.id == testafname.id) {
                            testafname.index = index;
                        }
                    });

                    $scope.testafnames.push(testafname);
                });
                if (testafnames.length < pagesize) {
                    $scope.testafnamesMorePages = false;
                }
            });
        }
    };

    $scope.searchTestafname = function() {
        $scope.testafnamesPage = 1;
        $scope.testafnames = [];
        $scope.testafnamesMorePages = true;
        $scope.loadTestafnames();
    };

    $scope.addTestafname = function(testafname) {
        var index = testafname.index;
        if (index < 0) {
            testafname.index = $scope.p2c.testafnames.length;
            $scope.p2c.testafnames.push(testafname);
        }
    };

    $scope.deleteTestafname = function(testafname) {
        var index = testafname.index;
        $scope.p2c.testafnames.splice(index, 1);
        testafname.index = -1;
        angular.forEach($scope.p2c.testafnames, function (testafname, index) {
            testafname.index = index;
        });
    };

    $scope.next = function() {
        if (p2cService.model.testafnames.length > 0) {
            p2cService.SaveState();
            $state.go('matching/p2c/ideaalscores');
        }
    };

});